import React from 'react';
import { BadgeCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { FeatureList, PlanCardShell, Price } from './PlanCardShell';

export const FreePlanCard = ({ plan, onStart }) => (
  <PlanCardShell tone="free" title="Free" testId="pricing-card-free"
    subtitle="Try Schedule Guru's scheduling for free, for as long as you like."
    control={<span className="inline-flex items-center gap-1.5 rounded-full bg-slate-100 px-3 py-1.5 text-xs font-semibold text-slate-600"><BadgeCheck className="w-3.5 h-3.5" />No card required</span>}
    price={<><Price amount={0} unit="forever" currency={false} testId="plan-price-free" /><p className="text-sm text-slate-500 mt-3">Free plan with no time limit.</p></>}
    features={<FeatureList items={plan?.features || []} limits={['No brackets, live stats or AI tools']} testId="free-features" />}
    footer={(
      <Button variant="outline" onClick={onStart} className="w-full h-12 border-2 border-[#00247D] text-[#00247D] font-bold hover:bg-[#00247D] hover:text-white transition-colors" data-testid="select-plan-free">
        Get Started Free
      </Button>
    )} />
);
